<template>
  <div class="pay-center-payment">
    <div class="pay-center-payment-header">支付方式</div>
    <div class="pay-center-payment-content">
      <div class="pay-center-payment-info">
        <ym-img v-if="payment.icon === 'balance-pay'"
                class="pay-center-payment-info-icon-img"
                :src="require('@/assets/img/pay_center/balance_icon.png')"
        />
        <ym-icon v-else
                 class="pay-center-payment-info-icon"
                 :class="`is-${payment.icon}`"
                 :name="payment.icon"
        />
        <span class="pay-center-payment-info-title">{{ payment.text }}</span>
        <div v-if="payment.icon === 'balance-pay' && balancePay"
             class="pay-center-payment-info-balance-block ym-line-ellipsis"
        >
          <div class="pay-center-payment-info-balance-count">
            {{ balancePay.balance }} 少商币
          </div>
          <div v-if="balancePay.showRechargeBtn"
               class="pay-center-payment-info-balance-hint"
          >
            （不足支付）
          </div>
        </div>
      </div>
      <div class="pay-center-payment-action">
        <div v-if="balancePay && balancePay.showRechargeBtn"
             class="pay-center-payment-action-recharge-btn"
             v-ym-report:PAY_CENTER_RECHARGE_EXPOSURE|PAY_CENTER_RECHARGE_CLICK=""
             @click="handleRecharge"
        >
          充值
        </div>
        <ym-icon v-else
                 class="pay-center-payment-action-icon"
                 name="round-check-fill-fat"
        />
      </div>
    </div>
  </div>
</template>

<script>
  import { locationHref } from '@/utils';
  import validator from '@/utils/validator';

  export default {
    name: 'PayCenterPayment',
    props: {
      payment: {
        type: Object,
        required: true,
      },
      balancePay: {
        validator(val) {
          return validator.isObject(val);
        },
        required: true,
      },
    },
    methods: {
      handleRecharge() {
        if (this.balancePay.rechargePath && this.balancePay.rechargePath !== '') {
          locationHref(this.balancePay.rechargePath);
        }
      },
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .pay-center-payment {
    box-sizing: border-box;
    padding: 36px 30px;
    background: @color-white;
    &-header {
      margin-bottom: @size-base;
      color: @color-text-base;
      font-size: @font-size-base;
      font-weight: @font-weight-strong;
      line-height: 1;
    }
    &-content {
      box-sizing: border-box;
      position: relative;
      width: 100%;
      height: 80px;
      padding: 0 @size-small;
      display: flex;
      align-items: center;
      background: #f5f6f7;
      border-radius: 8px;
    }
    &-info {
      display: flex;
      align-items: center;
      &-icon-img {
        width: 32px;
        height: 32px;
      }
      &-icon {
        color: #09bb07;
        font-size: 34px;
      }
      &-title {
        margin-left: 16px;
        color: @color-text-light;
        font-size: @font-size-base;
        line-height: 1;
      }
      &-balance {
        &-block {
          width: 400px;
          box-sizing: border-box;
          padding-left: 14px;
          display: flex;
          align-items: center;
        }
        &-count {
          color: #13b9bf;
          font-size: @font-size-base;
          font-weight: @font-weight-strong;
          line-height: 1;
        }
        &-hint {
          color: #fa405e;
          font-size: @font-size-base;
          line-height: 1;
        }
      }
    }
    &-action {
      position: absolute;
      right: 20px;
      &-recharge-btn {
        width: 120px;
        height: 60px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: @color-white;
        font-size: @font-size-base;
        font-weight: @font-weight-strong;
        line-height: 1;
        background: #02cccc;
        border-radius: 8px;
      }
      &-icon {
        color: #02cccc;
        font-size: @font-size-extra-large;
      }
    }
  }

</style>
